import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUserAction } from "../redux/slices/userSlices";
import Team from "./Team";
import EditProfile from "./EditProfile";
import ChangePassword from "./ChangePassword";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/profilepage.css";
import "../styles/editProfile.css";
import {
  leaderboardAction,
  userDetailAction,
  changePrevLinkAction,
} from "../redux/slices/userSlices";
import UserNav from "./UserNav";
import { useNavigate } from "react-router-dom";

const UserProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const UserstoreData = useSelector((store) => store?.users);
  const { user, leaderBoard, rank } = UserstoreData;

  const [activeComponent, setActiveComponent] = useState("team");

  useEffect(() => {
    dispatch(userDetailAction());
    dispatch(leaderboardAction());
  }, [dispatch]);

  if (!user) {
    const data = {
      prevLink: "/Userprofile",
    };
    dispatch(changePrevLinkAction(data));
    navigate('/login');
  }

  const changeForm = (data)=>
  {
    setActiveComponent(data);
    
  }

  const handleLogout = () => {
    dispatch(logoutUserAction());
    const data = {
      prevLink: "/",
    };
    dispatch(changePrevLinkAction(data));
    localStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <UserNav />
      <div className="profile-wrapper">
        <div className="profile-content">
          <div className="profile-info">
            <img
              src={user?.profilePic}
              alt="profile"
              className="profile-image"
            />
            <div className="profile-details">
              <h4>{user?.name}</h4>
              <p>{user?.email}</p>
              <p>Rank: {rank} | Score: {Math.floor(user?.score)}</p>
              <p>{user?.college}</p>
            </div>
            <div className="profile-actions">
              
              <button onClick={() => changeForm("editProfile")}><a href="#editForm" style={{textDecoration : 'none' , color : "black"}}>Edit Profile</a></button>
              
              <button onClick={() => changeForm("changePassword")}><a href="#editForm" style={{textDecoration : 'none' , color : "black"}}>Update Password</a></button>
              <button onClick={() => changeForm("team")}><a href="#editForm" style={{textDecoration : 'none' , color : "black"}}>Team Details</a></button>
              <button onClick={handleLogout}>Log Out</button>
              
            </div>
            
          </div>
          <div id="editForm"></div>
          <div className="rendered-component">
            {activeComponent === "team" && <Team />}
            {activeComponent === "editProfile" && <EditProfile />}
            {activeComponent === "changePassword" && <ChangePassword />}
          </div>
          
        </div>
        <div className="leaderboard-section">
          <h2>Leaderboard</h2>
          <div className="leaderboard-table">
            <table>
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Email</th>
                  <th>College</th>
                  <th>Score</th>
                </tr>
              </thead>
              <tbody>
                {leaderBoard ? (
                  leaderBoard.map((userRank, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{userRank.email}</td>
                      <td>{userRank.college}</td>
                      <td>{Math.floor(userRank.score)}</td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="4">No leaderboard data available</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        
      </div>
    </>
  );
};

export default UserProfile;